import { LifecycleModel } from "./lifecyclemodel";

export class UpdateMetaDataModel {
    name: string = "";
    description?: string = "";
    lifecycle?: LifecycleModel;
    version: number;
    thirdPartyId?: string;
    contractId?: string;
    ownerId?: string;
    owningOrganizationId?: string;
}
